2
<template>
  <div class="container">
    <!-- 	  <Header lineIsShow="1"></Header> -->
    <div class="top" style="display: flex;justify-content: space-between;">
      <div style="width:100%;max-width:1200px;margin:0px auto;">
        <div style="margin-top: 18px;color: white;margin-right: 20px;position: absolute;right: 0px;font-size: 15px;">
          <router-link :to="{ name: 'Complain_info' }" style="color: white;">投诉建议</router-link>
        </div>
        <div class="logo">
          <router-link to="/"><img src="../assets/logo.png" /></router-link>
        </div>
        <ul class="pc pcnav">
          <li><router-link :to="{ name: 'Common_product' }">产品介绍</router-link></li>
          <li class="currents"><router-link :to="{ name: 'Common_introduce' }">公司介绍</router-link></li>
          <li><router-link :to="{ name: 'Common_video' }">实时监控</router-link></li>
          <!-- <li><router-link :to="{ name: 'Common_drew' }">码上有礼</router-link></li> -->
        </ul>
        <div class="qh" style="margin-top: 18px;color: white;margin-right: 20px;">
          <a href="javascript:void(0)" @click="getIntegral" class="integral-btn">
            <img style="width:20px;vertical-align: text-bottom;" src="../assets/icon-jifen.png" />
            积分获取
          </a>
        </div>
      </div>
    </div>
    <ul class="nav">
      <li style="position: relative"><router-link :to="{ name: 'Common_product' }">产品介绍</router-link></li>
      <li class="position: relative"><router-link :to="{ name: 'Common_introduce' }">企业介绍</router-link></li>
      <li style="position: relative"><router-link :to="{ name: 'Common_video' }">实时监控</router-link></li>
      <li class="current">
        <!-- <router-link :to="{ name: 'Common_drew' }">码上有礼</router-link> -->
        <p class="ui-line"></p>
      </li>
    </ul>

<!--    <div class="turntable">
      点击时候转动转盘 指针不转
      <img
        class="turntable-center"
        :style="{ transform: rotateAngle, transition: rotateTransition == '' ? 'transform 4s ease-in-out' : rotateTransition }"
        src="../assets/turnplate-bg.png"
      />
      <img class="turntable-top" @click="luckflag ? pointer() : ''" src="../assets/turnplate-pointer.png" />
    </div> -->
    <button type="button" class="prize-info-list" @click="prizeInfoList()">获奖记录</button>
    <div class="prize-info-div" v-show="prizeInfoShow">
      <button type="button" @click="closePrizeInfoDiv()">X</button>
      <ul>
        <li>
          <span class="prize-name">奖品名称</span><span>获奖时间</span>
        </li>
        <li v-for="prizeInfo in prizeInfos">
          <span class="prize-name">{{ prizeInfo.prizeName }}</span><span>{{ prizeInfo.time }}</span>
        </li>
      </ul>
    </div>


    <img src="../assets/flash.png" id="shan-img" style="display:none;" />
    <img src="../assets/thanks.png" id="sorry-img" style="display:none;" />
    <div class="banner">
    	<div class="turnplate">
        <div class="turntable-center" :style="{ transform: rotateAngle, transition: rotateTransition == '' ? 'transform 4s ease-in-out' : rotateTransition }">
          <canvas class="item" id="wheelcanvas" width="422px" height="422px"></canvas>
        </div>
    		<img class="pointer" src="../assets/turnplate-pointer.png" @click="luckflag ? pointer() : ''"/>
    	</div>
    </div>
    <div style="text-align: center;margin-top: 5%;padding-bottom: 5%;">剩余次数:{{click_num}}</div>

    <div class="root" v-if="rootShow">
        <el-form label-width="0" class="RegisterForm">
            <el-form-item prop="phone" class="phone">
                <el-input class="phone-input" v-model="phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item prop="验证码" class="code">
                <el-input class="code-input" v-model="code" placeholder="请输入验证码"></el-input>
                <el-button class="sendsms-button" type="button" @click="sendSms()" :disabled="disabled" v-if="disabled==false">发送验证码
                </el-button>
                <el-button class="sendsms-button" type="button" @click="sendSms()" :disabled="disabled" v-if="disabled==true">{{btntxt}}
                </el-button>
            </el-form-item>

            <el-form-item class="sumbit-button">
                <el-button type="primary" @click="getlotteryPrizeFun()">提交</el-button>
                <el-button type="primary" @click="closePhoneCode()">取消</el-button>

            </el-form-item>
        </el-form>
    </div>
    <cp-footer></cp-footer>
  </div>
</template>

<script>
import cpFooter from '@/views/footer';
import { suyuanDrewCount, suyuanDrewPrizeInfo, suyuanDrewSendCode, suyuanDrewCheckPhoneCode, suyuanDrewUserPrizeInfo } from '@/api/api';
export default {
  name: 'Common_introduce',
  components: {
    cpFooter
    // Header
  },
  data() {
    return {
      num: '',
      data: {},
      luckflag: true,
      rotateAngle: 0, //将要旋转的角度
      startRotatingDegree: 0, //初始旋转角度
      rotateTransition: '', //控制过渡效果
      click_flag: true, //是否可以旋转抽奖
      click_num: 0,
      phone: "",
      code: "",
      prizeList: [],
      colors:[],					//大转盘奖品区块对应背景颜色
      outsideRadius:192,			//大转盘外圆的半径
      textRadius:155,				//大转盘奖品位置距离圆心的距离
      insideRadius:68,			//大转盘内圆的半径
      startAngle:0,				//开始角度
      bRotate:false,				//false:停止;ture:旋转
      disabled: false,
      time: 0,
      btntxt: "重新发送",
      rootShow: false,
      prizeInfoShow: false,
      prizeInfos: [{prizeName:'',time:''}]
    };
  },
  watch: {
    $route(to, from) {
      if (/\/Common_introduce/gi.test(to.path)) {
        this.num = localStorage.getItem('zymCode');
      }
    }
  },
  created() {
    this.num = localStorage.getItem('zymCode');
    this.getActcivityFancy();
    this.prizeConfig();
  },
  watch: {
    $route: 'integralData'
  },
  methods: {
    prizeInfoList(){
      var phone = localStorage.getItem("phoneNumber");
      if(phone){
        let parmas = {
          phone: phone
        };
        suyuanDrewUserPrizeInfo(parmas).then(res => {
          this.prizeInfos = res.data.data;
        })
      }
      this.prizeInfoShow = true;
    },
    closePrizeInfoDiv(){
      this.prizeInfoShow = false;
    },
    closePhoneCode(){
      this.rootShow = false;
    },
    getIntegral() {
      var _this = this;
      var wx_code = _this.$route.query.code;
      var wx_state = _this.$route.query.state;
      if (!wx_code && !wx_state) {
        _this
          .$axios({
            method: 'get',
            url: 'portal/integral/verify/count/' + _this.num
          })
          .then(res => {
            if (res.data.code == 0) {
              if (res.data.data <= 0) {
                var appid = 'wxfe3edde0e854125b';
                var scope = 'snsapi_userinfo';
                var auth_url =
                  'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
                  appid +
                  '&redirect_uri=' +
                  encodeURIComponent(window.location.href) +
                  '&response_type=code&scope=' +
                  scope +
                  '&state=' +
                  _this.num +
                  '#wechat_redirect';
                window.location.replace(auth_url);
              } else {
                _this.$Message.error('此积分已被获取!');
              }
            } else {
              _this.$Message.error(res.data.msg);
            }
          })
          .catch(err => {
            alert(err);
            console.log(err);
          });
      } else {
        _this.$Message.error('您已获取积分!');
      }
    },

    // 点击指针
    pointer() {
      const that = this;
      if (!that.click_flag) return;
      if(that.click_num > 0){
        //弹出来验证码框
        this.rootShow = true;
      }else{
        that.$message({
          message: "此码抽奖次数已用完",
          type: "error"
        });
      }
    },
    // 转动
    rotate(prize) {
      console.log(prize)
      //目前是只转动转盘
      if (!this.click_flag) return;
      this.bRotate = !this.bRotate;

      var rotateAngle = '';
      var randCircle = 10;
      var duringTime = 4;
      var prizeLength = this.prizeList.length;
      // var rotateCentent = (360/prizeLength)/2 + (prizeLength - prize.prizeIndex) * (360/prizeLength);
      var rotateCentent = 360 - (360 / prizeLength) * (prize.prizeIndex + 1);
      console.log("rotateCentent=",rotateCentent);
      rotateAngle = randCircle * 360 + rotateCentent;
      var rotateAngle = this.startRotatingDegree + rotateAngle - (this.startRotatingDegree % 360); //将要旋转的角度
      this.startRotatingDegree = rotateAngle; //改变初始旋转的角度
      this.rotateAngle = 'rotate(' + rotateAngle + 'deg)'; //真正控制转动角度

      setTimeout(()=>{
            this.bRotate = !this.bRotate;
            this.click_flag = true;
            this.gameOver(prize);
        }, duringTime * 1000+500)

      // $('#wheelcanvas').stopRotate();
      // $('#wheelcanvas').rotate({
      // 	angle:0,
      // 	animateTo:angles+1800,
      // 	duration:8000,
      // 	callback:function (){
      //     this.click_flag = true;
      //     this.gameOver(prize);
      // 		this.bRotate = !this.bRotate;
      // 	}
      // });



      // var type = 0; // 默认为 0  转盘转动
      // var randCircle = 10; // 附加多转几圈，2-3
      // var duringTime = 5; // 默认为 5s
      // var rotateAngle = '';
      // var prizeLength = this.prizeList.length;
      // var rotateCentent = (360/prizeLength)/2 + (prizeLength - prize.prizeIndex) * (360/prizeLength);
      // rotateAngle = randCircle * 360 + rotateCentent;
      // this.click_flag = false; // 旋转结束前，不允许再次触发
      // if (type == 0) {
      //   // 转动盘子
      //   var rotateAngle = this.startRotatingDegree + rotateAngle - (this.startRotatingDegree % 360); //将要旋转的角度
      //   this.startRotatingDegree = rotateAngle; //改变初始旋转的角度
      //   this.rotateAngle = 'rotate(' + rotateAngle + 'deg)'; //真正控制转动角度
      //   // 旋转结束后允许再次触发
      //   setTimeout(()=>{
      //       this.click_flag = true;
      //       this.gameOver(prize)
      //   }, duringTime * 1000+200)
      // }
    },
    // 游戏结束
    gameOver(prize) {
      // 游戏结束,重置旋转初始位置
      // this.rotateAngle = 'rotate(' + 0 + 'deg)'; //真正控制转动角度的,为0,回到初始位置
      // this.rotateTransition = 'transform 0.05s ease-in-out'; //控制转动过渡效果的
      // setTimeout(() => {
      //   this.rotateTransition = '';
      // }, 100);
      // 中奖弹窗提示
      // this.isShowMask = true;
      // this.winAward = true;
      this.$message({
        duration: 10000,
        message: '您抽中 '+prize.prizeName,
        type: "success",
        showClose: true
      })
      // 更新抽奖次数
      this.getActcivityFancy();
    },
    // 请求活动页面数据
    getActcivityFancy() {
      const me = this;
      let parmas = {
        zymCode: me.num
      };
      suyuanDrewCount(parmas).then(res => {
        this.click_num = res.data.data;
        if(this.click_num <= 0){
          this.click_flag = false;
        }
      });
    },
    prizeConfig(){
      suyuanDrewPrizeInfo().then(res => {
        if(res.data.data){
          // this.prizeList = res.data.data;
          for(var i = 0; i < res.data.data.length; i++){
            if(this.prizeList){
              this.prizeList.unshift(res.data.data[i])
            }else{
              this.prizeList.push(res.data.data[i])
            }
            if(((i+1)/2)%1 == 0){
              this.colors.push("#FFF4D6");
            }else{
              this.colors.push("#FFFFFF");
            }
          }
          console.log(this.prizeList);
          this.drawRouletteWheel();
        }
      });
    },
    //请求验证码验证与抽奖
    getlotteryPrizeFun() {
      const that = this;
      if(!that.phone){
        that.$Message.info("手机号不能为空");
        return;
      }
      if(!that.code){
        that.$Message.info("验证码不能为空");
        return;
      }
      if(that.prizeList){
        let data = {
          phone: that.phone,
          code: that.code,
          zymCode: that.num
        }
        suyuanDrewCheckPhoneCode(data).then(res => {
          if(res.data.code == 0){
            localStorage.setItem("phoneNumber", that.phone);
            this.closePhoneCode();
            that.rotate(res.data.data);
          }else{
            that.$Message.error(res.data.msg);
          }
        })
      }
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后重新获取";
        setTimeout(this.timer, 1000);
       } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
       }
    },
    sendSms(){
      const that = this;
      if(!that.phone){
        that.$Message.info("手机号不能为空");
        return;
      }
      let data = {
        phone: that.phone
      }
      suyuanDrewSendCode(data).then(res => {
        that.$message({
          message: '短信验证码发送成功',
          type: 'success'
        })
        that.time = 60;
        that.disabled = true;
        that.timer();
      })
    },
    drawRouletteWheel() {
      let that = this;
      var canvas = document.getElementById("wheelcanvas");
      if (canvas.getContext) {
    	  //根据奖品个数计算圆周角度
    	  var arc = Math.PI / (that.prizeList.length/2);
    	  var ctx = canvas.getContext("2d");
    	  //在给定矩形内清空一个矩形
    	  ctx.clearRect(0,0,422,422);
    	  //strokeStyle 属性设置或返回用于笔触的颜色、渐变或模式
    	  ctx.strokeStyle = "#FFBE04";
    	  //font 属性设置或返回画布上文本内容的当前字体属性
    	  ctx.font = '16px Microsoft YaHei';
    	  for(var i = 0; i < that.prizeList.length; i++) {
    		  var angle = that.startAngle + i * arc;
    		  ctx.fillStyle = that.colors[i];
    		  ctx.beginPath();
    		  //arc(x,y,r,起始角,结束角,绘制方向) 方法创建弧/曲线（用于创建圆或部分圆）
    		  ctx.arc(211, 211, that.outsideRadius, angle, angle + arc, false);
    		  ctx.arc(211, 211, that.insideRadius, angle + arc, angle, true);
    		  ctx.stroke();
    		  ctx.fill();
    		  //锁画布(为了保存之前的画布状态)
    		  ctx.save();

    		  //----绘制奖品开始----
    		  ctx.fillStyle = "#E5302F";
    		  var text = that.prizeList[i].prizeName;
          console.log(that.prizeList[i].prizeName,"===",that.prizeList[i].prizeIndex);
    		  var line_height = 17;
    		  //translate方法重新映射画布上的 (0,0) 位置
    		  ctx.translate(211 + Math.cos(angle + arc / 2) * that.textRadius, 211 + Math.sin(angle + arc / 2) * that.textRadius);

    		  //rotate方法旋转当前的绘图
    		  ctx.rotate(angle + arc / 2 + Math.PI / 2);

    		  /** 下面代码根据奖品类型、奖品名称长度渲染不同效果，如字体、颜色、图片效果。(具体根据实际情况改变) **/
    		  // if(text.indexOf("M")>0){//流量包
    			 //  var texts = text.split("M");
    			 //  for(var j = 0; j<texts.length; j++){
    				//   ctx.font = j == 0?'bold 20px Microsoft YaHei':'16px Microsoft YaHei';
    				//   if(j == 0){
    				// 	  ctx.fillText(texts[j]+"M", -ctx.measureText(texts[j]+"M").width / 2, j * line_height);
    				//   }else{
    				// 	  ctx.fillText(texts[j], -ctx.measureText(texts[j]).width / 2, j * line_height);
    				//   }
    			 //  }
    		  // }else if(text.indexOf("M") == -1 && text.length>6){//奖品名称长度超过一定范围
    			 //  text = text.substring(0,6)+"||"+text.substring(6);
    			 //  var texts = text.split("||");
    			 //  for(var j = 0; j<texts.length; j++){
    				//   ctx.fillText(texts[j], -ctx.measureText(texts[j]).width / 2, j * line_height);
    			 //  }
    		  // }else{
    			  //在画布上绘制填色的文本。文本的默认颜色是黑色
    			  //measureText()方法返回包含一个对象，该对象包含以像素计的指定字体宽度
    			  ctx.fillText(text, -ctx.measureText(text).width / 2, 0);
    		  // }

    		  //添加对应图标
    		  if(text.indexOf("谢谢参与")>=0){
    			  var img= document.getElementById("sorry-img");
    			  img.onload=function(){
    				  ctx.drawImage(img,-15,20);
    			  };
    			  ctx.drawImage(img,-15,20);
    		  }else{
            var img= document.getElementById("shan-img");
            img.onload=function(){
              ctx.drawImage(img,-15,20);
            };
            ctx.drawImage(img,-15,20);
          }
    		  //把当前画布返回（调整）到上一个save()状态之前
    		  ctx.restore();
    		  //----绘制奖品结束----
    	  }
      }
    }
  }
};
</script>

<style scoped>
    .prize-info-div{
      position: absolute;
      background: rgba(0,0,0,0.7);
      top: 0px;
      height: 100%;
      width: 100%;
      z-index: 100;
      color: white;
    }
    .prize-name{
      float: left;
    }
    .prize-info-div button{
      float: right;
      margin: 3% 3% 0 0;
      border-radius: 15px;
      width: 30px;
      height: 30px;
      background-color: #45b035;
      border: 0;
      color: white;
    }
    .prize-info-div ul{
      width: 100%;
      text-align: center;
      margin: 40% 0 0 0;
      font-size: 17px;
    }
    .prize-info-div ul li:first-child{
      padding: 0 0 0 0;
    }
    .prize-info-div ul li{
      padding: 2% 0 0 0;
    }
    .prize-info-div ul li span{
      width: 50%;
      text-align: center;
    }
    .prize-info-list{
      display: inline-block;
      width: 100%;
      height: 44px;
      line-height: 44px;
      font-size: 16px;
      text-align: center;
      color: #fff;
      background-color: #45b035;
      cursor: pointer;
      border: 0;
    }

    .prize-info-list:hover {
        background-color: #45b035;
    }

    .prize-info-list:active {
        background-color: #198c2f;
    }

    .sumbit-button{
      padding: 5% 0 0 0;
    }
    .sendsms-button{
      margin: 0 0 0 5%;
    }
    .phone-input{
      width: 80%;
      text-align: left;
    }
    .phone{
      text-align: left;
    }
    .code{
      text-align: left;
      padding: 5% 0 0 0;
    }
    .code-input{
      width: 50%;
    }
    .RegisterForm{
      position: absolute;
      top: 40%;
      left: 10%;
      text-align: center;
    }
    .root {
        position: absolute;
        background:rgba(0,0,0,0.6);
        top: 0px;
        height: 100%;
        width: 100%;
        display: table-cell;
        vertical-align: middle;
        /* form {
            width: 80%;
            margin: auto;
            margin-top: 90%;
            .code {
                .el-input {
                    width: 55%;
                    border-radius: 0px;
                    float: left;
                    display: inline-block;
                }
                .el-button {
                    width: 45%;
                    border-top-left-radius: 0px;
                    border-bottom-left-radius: 0px;
                    border-left: 0px;
                    float: left;
                    display: inline-block;
                }
            }
            .el-button--primary {
                width: 100%;
                background-color: #ffe86a;
                border: none;
                color: #000;
            }
        } */
    }
</style>

<style scoped>

  @import "../assets/css/luck-draw.css";
* {
  margin: 0;
}
.turnplate{
  background-image:url(../assets/turnplate-bg.png);
  background-size:100% 100%;
}
.turntable{
  text-align: center;
}
.turntable-top{
    position: absolute;
    left: 36%;
    top: 34%;
}
.bg {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: -1;
  background-color: #f5f5f5;
}
.top {
  height: 3rem;
  background-color: #45b035;
}
.logo {
  width: 25%;
  margin: 0px auto;
  line-height: 3rem;
}
.logo > a {
  display: inline-block;
  margin-top: 10%;
}
.logo img {
  display: block;
  width: 100%;
}
.tab {
  position: fixed;
  width: 100%;
  bottom: 0;
  border-top: 1px solid #f1ebeb;
  background-color: white;
}
.nav {
  list-style: none;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f1ebeb;
  background-color: white;
}
.nav a {
  color: #333333;
  margin: 12px 0;
  display: inline-block;
}
.nav .ui-line {
  width: 1.12rem;
  height: 0.1rem;
  background-color: #39bf3e;
  margin: 0px auto;
}
.nav li {
  width: 33%;
}
.nav li:hover {
  color: #45b035;
}
.current a {
  color: #45b035;
}
.banner img {
  width: 100%;
}
.introduce {
  text-align: left;
  font-size: 0.8rem;
  color: #333;
  padding: 0rem 1rem;
  background-color: white;
  margin: 23px 20px 0px 20px;
  padding: 0.8rem;
  border-radius: 15px;
  z-index: 1;
  position: relative;
  top: -12px;
}
.isNoImg {
  top: 0;
  margin: 0;
  border-radius: 0;
  margin-bottom: 0;
  top: -10px;
}

.introduce p {
  margin-bottom: 0.4rem;
}
.store {
  background-color: white;
  padding: 0.8rem;
}
h3 {
  font-size: 0.9rem;
  text-align: left;
  position: relative;
  padding-left: 20px;
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 10px;
}
h3:before {
  position: absolute;
  content: '';
  left: 10px;
  top: 0;
  width: 3px;
  height: 16px;
  background-color: #45b035;
}
.img_content {
  display: flex;
  margin: 10px 0;
  justify-content: space-around;
}
.store p {
  width: 30%;
}
.store p img {
  width: 100%;
}
.list {
  padding-bottom: 60px;
  margin-top: 10px;
}
.left_img {
  width: 30%;
}
.left_img img {
  width: 100%;
}
.list_content {
  display: flex;
  padding: 5px;
  margin-top: 10px;
  box-shadow: 0px 0px 3px #ece6e6;
}
.title {
  width: 70%;
  text-align: left;
}
h4 {
  font-size: 1rem;
  margin-top: 1.3rem;
  color: #2c3e50;
  margin-left: 1rem;
}
.sub {
  font-size: 0.8rem;
  margin-top: 1.3rem;
  color: red;
  margin-left: 1rem;
}
.more {
  float: right;
  color: #b8b8b8;
  font-size: 0.8rem;
}
.look {
  float: right;
  color: #45b035;
}
.it {
  font-size: 0.6rem;
  margin: 5px 0;
  margin-left: 1rem;
}
.img_content img {
  border-radius: 6px;
}
.ej {
  position: absolute;
  width: 100%;
  background-color: #45b035;
  left: 0;
  top: 38px;
  z-index: 100;
  text-align: right;
}
.ej li {
  width: 100%;
  text-align: center;
  color: white;
  border-bottom: 1px solid #fff;
}

.ej li a {
  width: 100%;
  text-align: center;
  color: white;
}
.ej li a:hover {
  color: white;
}

.pc {
  display: none;
}
.qh {
  display: none;
}
</style>
<style lang="scss" scoped>
@import '@/assets/css/rem.scss';
.container {
  background-color: #f5f5f5;
}
.container .mb {
  margin-bottom: rem(20);
}
.gs-logo {
  width: rem(60);
  height: rem(60);
}
.newsTitle {
  text-align: left;
  width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.shopList {
  font-size: 14px;
  padding: 12px 10px 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .shop {
    width: 30%;
    text-align: center;
    &:last-of-type {
      margin-right: 0;
    }
    > a {
      display: block;
      text-align: center;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
}
@media screen and (min-width: 1000px) {
  .pcintroduce {
    .shopList {
      padding-top: 40px;
    }
  }
}
.cube-slide .cube-slide-group .cube-slide-item {
  pointer-events: none;
}

.integral-btn-wrapper {
  width: 400px;
  padding: 50px;
  background-color: yellow;
}

.integral-btn {
  color: white;
  background: #dfab04;
  height: 58px;
  border: 2px solid #c1ac0e;
  font: 500 20px 'Raleway', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  padding: 0 10px;
  transition: color 0.1s linear, background-color 0.1s linear, border-color 0.1s linear;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.integral-btn:hover {
  background: #c1ac0e;
  border-color: #c1ac0e;
}

.integral-btn:active {
  background: #45b035;
  border-color: #c1ac0e;
}

   .input-wraps{
    width: 100%;
    height: 100%;
    position: fixed;
    left:0px;
    top:0px;
    text-align:center;
  }
  .input-wraps .bgbox{
    background:rgba(0,0,0,0.6);
    width:100%;
    height:100%;
  }
  .input-wraps .main{
    width: 50%;
    background-color: #FFFFFF;
    border-radius: 0.1rem;
    z-index:10;
    position: absolute;
    left: 25%;
    top:40%;
  }
    .input-wraps .main .close{
      position:absolute;
      right:-5px;
      top:-5px;
      display:block;
      width:20px;
      height:20px;
      border-radius:50%;
      border:1px solid green;
      font-size:10px;
      color:green;
      text-align:center;
      line-height:20px;
    }
  .input-wraps .main .content{

  }
  .input-wraps .main .item{
    overflow:hidden;
    padding:10px 0px;
  }
  .input-wraps .main .item .label{
    float:left;
    font-size:14px;
    width:30%;
  }
  .input-wraps .main .item input{
    float:left;
    width:50%;
  }
  .input-wraps .main .item .get-code{
    width:20%;
    font-size:14px;
    float:left;
  }
</style>



// WEBPACK FOOTER //
// src/components/Common_drew.vue